import React from 'react';
import classnames from 'classnames'

import './stylesheets/modal.scss'

export default class Modal1 extends React.Component {
  static defaultProps = {
    width: '457'
  }

  close = () => {
    this.props.close()
  }
  render () {
    return (
      <div className={classnames(
        "modal-wrap fade",
        !this.props.state ? 'modal-wrap-hiden' : '',
        this.props.className
      )}>
        <div className="modal" style={{
          width: this.props.width + 'px'
        }}>
          {this.props.close ? <div className="model-close" onClick={this.close}></div> : ''}
          {this.props.title ? <div className="title">{this.props.title}</div> : ''}
          <div className="modal-body">
            {this.props.state && this.props.children}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/formList/modal/modal.js